import { Injectable, inject } from '@angular/core';

import { LinkViewModel } from '@frontend/sports/types/models/link';
import { NativeAppService } from '@frontend/vanilla/core';

export enum CCBEventFeature {
    Banner = 'Banner',
    Marquee = 'Marquee',
}

enum CCBEventName {
    Quick_Game = 'OPEN_QUICK_GAME',
}

@Injectable({ providedIn: 'root' })
export class CCBEventService {
    private nativeAppService = inject(NativeAppService);

    sendCCBToNative(link: LinkViewModel | undefined, feature: string): boolean {
        const ccbKey = this.getAttribute(link, 'ccbkey');
        if (this.nativeAppService.isNative && ccbKey === CCBEventName.Quick_Game) {
            this.nativeAppService.sendToNative({
                eventName: ccbKey,
                parameters: {
                    featureId: `Slider_${feature}_Event`,
                    gameName: this.getAttribute(link, 'gamename'),
                    gameId: this.getAttribute(link, 'gameid'),
                },
            });

            return true;
        }

        return false;
    }

    private getAttribute(link: LinkViewModel | undefined, key: string): string {
        return link?.attributes?.[`data-${key}`] ?? '';
    }
}
